import React, { Suspense } from 'react'

import { useAppSelector } from 'reduxTyped'
import { getIsV3 } from 'common/billing/entities/billingVersions/selectors'
import { isWebViewRoute } from 'utils/router/tools'
import { safeReactLazy } from 'utils/safeReactLazy'

const StripeCheckoutStatusAlerts = safeReactLazy(
  () => import('common/billing/components/StripeCheckoutStatusAlerts'),
)
const AsyncStripeClientCredentialsView = safeReactLazy(
  () => import('common/billing/components/AsyncStripeClientCredentialsView'),
)
const TaxNumberForm = safeReactLazy(() => import('common/billing/components/TaxNumberForm'))

const UpgradeModal = safeReactLazy(() => import('common/billing/components/UpgradeModal'))

const WalletModals = safeReactLazy(() => import('common/billing/wallet/components/WalletModals'))

const BlockedProModal = safeReactLazy(
  () => import('common/billing/components/BlockedProModal/BlockedProModal'),
)

const PaymentCardRenewalModal = safeReactLazy(
  () => import('common/billing/components/PaymentCardRenewalModal/PaymentCardRenewalModal'),
)

const UkraineReliefProgramModal = safeReactLazy(
  () => import('common/billing/components/UkraineReliefProgramModal/UkraineReliefProgramModal'),
)

const BillingNextActionModal = safeReactLazy(
  () => import('common/billing/components/BillingNextActionModal'),
)

const CancelAddOnModal = safeReactLazy(() => import('common/billing/components/CancelAddOnModal'))

const PayNowModal = safeReactLazy(() => import('common/billing/components/PayNowModal/PayNowModal'))

const Confirm3DSModal = safeReactLazy(() => import('common/billing/components/Confirm3DSModal'))

const ConfirmCardVerification = safeReactLazy(
  () => import('common/billing/components/ConfirmCardVerificationModal'),
)

const OveragesManagingModal = safeReactLazy(
  () => import('common/billing/components/OveragesManagingModal'),
)

const MigrateFreeUsersToNewBillingModal = safeReactLazy(
  () => import('common/billing/components/MigrateFreeUsersToNewBillingModal'),
)

const SubscriptionSuccessModal = safeReactLazy(
  () => import('common/billing/components/SubscriptionSuccessModal'),
)

export const BillingModals = () => {
  const isWebView = isWebViewRoute()
  const isV3 = useAppSelector(getIsV3)

  return (
    <Suspense>
      <StripeCheckoutStatusAlerts />
      <AsyncStripeClientCredentialsView />
      <TaxNumberForm />
      <CancelAddOnModal />
      <BillingNextActionModal />
      <WalletModals />
      {!isWebView && <BlockedProModal />}
      <PaymentCardRenewalModal />
      <PayNowModal />
      <UpgradeModal />
      <UkraineReliefProgramModal />
      <Confirm3DSModal />
      <ConfirmCardVerification />
      <MigrateFreeUsersToNewBillingModal />
      {isV3 && <OveragesManagingModal />}
      <SubscriptionSuccessModal />
    </Suspense>
  )
}
